export interface RecaptchaOptions {
  useRecaptchaNet?: boolean
}

declare const window: Window &
  typeof globalThis & {
    recaptchaOptions?: RecaptchaOptions
  }

interface UseRecaptchaOptionsConfig extends RecaptchaOptions {
  enabled?: boolean
}

export function configureRecaptcha({ enabled = true, ...options }: UseRecaptchaOptionsConfig) {
  const { useRecaptchaNet } = options
  if (!enabled || typeof window === 'undefined') {
    return
  }

  window.recaptchaOptions = {
    ...window.recaptchaOptions,
    ...(useRecaptchaNet === undefined ? {} : { useRecaptchaNet }),
  }
}
